export default "__VITE_ASSET__CU2x5Grv__ 640w, __VITE_ASSET__CauiJU7Y__ 1024w, __VITE_ASSET__BKorp3gd__ 1200w";